export { EloGooglePayIcon } from './google-pay-icon'
